import React, { useState } from "react";
import { Button, ButtonGroup } from "reactstrap";

interface RatingProps {
  totalStars?: number;
  initialValue?: number;
  onChange?: (rating: number) => void;
  isDisabled?: boolean;
}

const Rating: React.FC<RatingProps> = ({
  totalStars = 5,
  initialValue = 0,
  onChange,
  isDisabled = false,
}) => {
  const [rating, setRating] = useState(initialValue);
  const [hover, setHover] = useState<number | null>(null);

  const handleClick = (star: number) => {
    if (isDisabled) return;
    setRating(star);
    if (onChange) onChange(star);
  };

  return (
    <ButtonGroup>
      {Array.from({ length: totalStars }, (_, index) => {
        const starValue = index + 1;
        const active = starValue <= (hover ?? rating);

        return (
          <Button
            key={starValue}
            color="link"
            disabled={isDisabled}
            onClick={() => handleClick(starValue)}
            onMouseEnter={() => setHover(starValue)}
            onMouseLeave={() => setHover(null)}
            style={{ padding: "0 4px" }}
          >
            <i
              className={`bx ${active ? "bxs-star text-warning" : "bx-star text-warning"}`}
              style={{ fontSize: "18px" }}
            />
          </Button>
        );
      })}
    </ButtonGroup>
  );
};

export default Rating;
